(function () {
  "use strict";

  function normalizeKey(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function findSectionElement(name) {
    var target = normalizeKey(name);
    if (!target) return null;

    var anchors = document.querySelectorAll("[data-scroll-anchor]");
    for (var i = 0; i < anchors.length; i++) {
      if (normalizeKey(anchors[i].getAttribute("data-scroll-anchor")) === target) {
        return anchors[i];
      }
    }
    return null;
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger = event.target.closest("[data-scroll-to-section]");
      if (!trigger) return;

      var name = trigger.getAttribute("data-scroll-to-section");
      var section = findSectionElement(name);

      if (!section) {
        console.warn(
          '[scroll-to-section] No section found matching "' +
            name +
            '". Check the section\'s "Scroll Anchor Name" setting against these anchors found on this page:',
          Array.prototype.map.call(document.querySelectorAll("[data-scroll-anchor]"), function (el) {
            return el.getAttribute("data-scroll-anchor");
          })
        );
        return;
      }

      event.preventDefault();
      section.scrollIntoView({
        block: "start",
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches
          ? "smooth"
          : "auto",
      });
    },
    true
  );
})();
